import { css, Global } from '@emotion/react';
import { Tooltip } from '@ui/tooltip';
import { rem } from '@utils';
import type { PropsWithChildren, ReactNode } from 'react';
import { Fragment } from 'react';
import Styled from './Card.styled';

interface Props extends PropsWithChildren {
  disabled?: boolean;
  icon?: ReactNode;
  onClick?: () => void;
}

function Card(props: Props) {
  const tooltipContent = props.disabled
    ? 'Upgrade your plan to select this prompt'
    : null;

  const handleClick = () => {
    if (!props.disabled) {
      props.onClick();
    }
  };

  return (
    <Fragment>
      <Global styles={styles} />
      <Styled.Wrapper
        disabled={props.disabled}
        data-testid="suggested-question"
        onClick={handleClick}
        tabIndex={0}>
        <Tooltip
          className="card-tooltip"
          classesPopper="card-tooltip-popper"
          content={tooltipContent}
          enterDelay={200}
          followCursor
          leaveDelay={0}
          placement="bottom">
          <div>
            {props.icon && <Styled.Icon>{props.icon}</Styled.Icon>}
            <Styled.Content>{props.children}</Styled.Content>
          </div>
        </Tooltip>
      </Styled.Wrapper>
    </Fragment>
  );
}

const styles = css`
  .card-tooltip {
    display: flex;
    height: 100%;
  }

  .card-tooltip-popper {
    margin: ${rem(12)} 0 !important;
  }
`;

export default Card;
